import React, { useState, useEffect, useRef, useContext } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import AddBoxIcon from "@mui/icons-material/AddBox";

import { SnackContext } from "context/SnackProvider";
import instance, { getErrorMessage, mediaUploadLimit } from "api/definitions";
import PageContainer from "components/templates/PageContainer";

const CreateMedia = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    if (props.load) {
      setItems([]);
      setIsLoaded(false);
      instance.defaults.headers["Content-Type"] = "";
      const formdata = new FormData();
      formdata.append("csv_file", props.file);

      instance
        .post("upload/ensalamento", formdata)
        .then(function (response) {
          setIsLoaded(true);
          const result = response.data;
          if (!result.performed) {
            snackContext.setMessage("Erro", "error");
          } else {
            const resultData = result.result;
            if (resultData) {
              const linesArray = [];
              for (var [key, value] of Object.entries(resultData)) {
                const line = Number(key) + 1;
                linesArray.push(
                  <Typography color={!value.performed && "error"}>
                    Linha {line}: {value.msg}
                  </Typography>
                );
              }
              setItems(linesArray);
            }
            snackContext.setMessage(`Arquivo salvo com sucesso`, "success");
            props.handleClose();
          }
        })
        .catch(function (error) {
          setIsLoaded(true);
          if (error.response) {
            if (error.response.data) {
              const resultData = error.response.data.result;
              if (resultData) {
                const linesArray = [];
                for (var [key, value] of Object.entries(resultData)) {
                  const line = Number(key) + 1;
                  linesArray.push(
                    <Typography color="error">
                      Linha {line}: {value.msg}
                    </Typography>
                  );
                }
                setItems(linesArray);
              }
            }
          }
          const msg = getErrorMessage(error);
          snackContext.setMessage(msg, "error");
          props.handleClose();
        });
      instance.defaults.headers["Content-Type"] = "application/json";
    }
  }, [props, snackContext]);

  if (props.load && !isLoaded) return <CircularProgress />;
  if (isLoaded) {
    const text = items.map((item) => item);
    return <Box>{text}</Box>;
  }
};

const Fields = () => {
  const [load, setLoad] = useState(false);

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Nenhum arquivo selecionado");
  const [colorFileName, setColorFileName] = useState("");

  //const [errorName, setErrorName] = useState(false);

  const refInput = useRef(null);

  const [name, setName] = useState("Novo");

  const mediaLimitText = mediaUploadLimit + "MB";

  const handleClose = (event) => {
    handleDeleteAll();
  };

  const handleClickChoose = (event) => {
    refInput.current.click();
  };

  const handleChangeInput = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      const fileUploaded = event.target.files[0];
      setFile(fileUploaded);

      const uploadLimit = mediaUploadLimit * 1000000;

      if (fileUploaded.type === "text/csv") {
        if (fileUploaded.size < uploadLimit) {
          setFileName(fileUploaded.name);
          setColorFileName("primary.main");
        } else {
          setFileName(
            "Esse arquivo excede o tamanho máximo de " + mediaLimitText
          );
          setColorFileName("error.main");
        }
      } else {
        setFileName("Esse arquivo não está no formato CSV");
        setColorFileName("error.main");
      }
    } else {
      setFileName("Nenhum arquivo selecionado");
      setColorFileName("");
    }
  };

  const handleClickCreate = () => {
    if (!file) {
      alert("Por favor, escolha um arquivo.");
    } else setLoad(true);
  };

  const handleDeleteAll = () => {
    if (load) setLoad(false);
    setFile(null);
    setFileName("Nenhuma mídia selecionada");
    setColorFileName("");
    setName("");
    //if (errorName) setErrorName(false);
  };

  return (
    <>
      <Box component="form" encType="multipart/form-data" sx={{ mt: 4 }}>
        <Box sx={{ mb: 2 }}>
          <Typography>
            Depois de escolher um arquivo dentro do formato e tamanho
            permitidos, o botão "Cadastrar Reservas" vai aparecer.
          </Typography>
          <Typography>
            <strong>Formato do arquivo permitido:</strong> CSV
          </Typography>
          <Typography>
            <strong>Tamanho máximo do arquivo permitido:</strong>{" "}
            {mediaLimitText}
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleClickChoose}
              sx={{
                backgroundColor: "success.main",
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              }}
            >
              Escolher Arquivo
              <input
                type="file"
                ref={refInput}
                onChange={handleChangeInput}
                hidden
              />
            </Button>
          </Grid>
          <Grid
            item
            xs={6}
            sm={5}
            md={4}
            lg={3}
            sx={{ display: colorFileName === "primary.main" ? true : "none" }}
          >
            <Button fullWidth onClick={handleClickCreate} variant="contained">
              Cadastrar Reservas
            </Button>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography variant="h6" color={colorFileName}>
              Arquivo selecionado: {fileName}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box id="boxData" sx={{ mt: 2 }}>
        <CreateMedia
          file={file}
          name={name}
          load={load}
          handleClose={handleClose}
        />
      </Box>
    </>
  );
};

const ReservationNewMany = (props) => {
  return (
    <PageContainer maxWidth="lg" title={`Novas Reservas`} icon={<AddBoxIcon />}>
      <Fields />
    </PageContainer>
  );
};

export default ReservationNewMany;
